import React, { FC } from 'react';
import { TFadeProps } from './types/fade.type';

const FadeDownEffect: FC<TFadeProps> = ({ children, delay }) => {
  return (
    <div className="fade-down-effect" style={{ animationDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

export default FadeDownEffect;
